import DetailsBlock from './DetailsBlock';
import LabelText from './LabelText';
import moment from 'moment';
import FilesPreview from './FilesPreview';
import { isMuvaFreight } from '../utils/whitelabeling';
import './Details.scss';

export default function Details({ setStep, edit, formik, videosUrls, error }) {
  const {
    moveType,
    companyName,
    firstName,
    lastName,
    email,
    phone,
    zipFrom,
    countryFrom,
    addressFrom,
    suiteFrom,
    cityFrom,
    stateFrom,
    bedroomsFrom,
    parkingFrom,
    addressTo,
    suiteTo,
    cityTo,
    stateTo,
    zipTo,
    countryTo,
    bedroomsTo,
    parkingTo,
    pickUpDate,
    pickUpTime,
    storageRequired,
    noPacking,
    requirements,
  } = formik.values;

  return (
    <div className='details'>
      <DetailsBlock
        header='Contact Information'
        edit={edit}
        onClick={() => setStep(3)}
      >
        {companyName && <LabelText label='Company Name' text={companyName} />}
        <LabelText label='Full Name' text={`${firstName} ${lastName}`} />
        <LabelText label='Email Address' text={email} />
        <LabelText label='Phone Number' text={phone} />
      </DetailsBlock>
      <DetailsBlock header='Pickup' edit={edit} onClick={() => setStep(5)}>
        <LabelText
          label='Address'
          text={`${addressFrom} ${suiteFrom} ${cityFrom}, ${stateFrom} ${zipFrom}, ${
            countryFrom === 'US' ? 'USA' : countryFrom
          }`}
        />
        {moveType !== 'Freight' && (
          <LabelText label='Bedrooms' text={bedroomsFrom} />
        )}
        <LabelText label='Parking' text={parkingFrom} />
      </DetailsBlock>
      <DetailsBlock header='Dropoff' edit={edit} onClick={() => setStep(6)}>
        <LabelText
          label='Address'
          text={`${addressTo} ${suiteTo} ${cityTo}, ${stateTo} ${zipTo}, ${
            countryTo === 'US' ? 'USA' : countryTo
          }`}
        />
        {moveType !== 'Freight' && (
          <LabelText label='Bedrooms' text={bedroomsTo} />
        )}
        <LabelText label='Parking' text={parkingTo} />
      </DetailsBlock>
      <DetailsBlock
        header='Move Details'
        edit={edit}
        onClick={() => setStep(4)}
      >
        <LabelText
          label='Prefered Pickup Date'
          text={moment(pickUpDate).format('MMM D, YYYY')}
        />
        <LabelText label='Prefered Pickup Window' text={pickUpTime} />
        {!isMuvaFreight() && (
          <LabelText
            label='Storage'
            text={storageRequired ? 'Required' : 'Not required'}
          />
        )}
        <LabelText
          label='Options'
          text={noPacking ? 'Pack by owner' : 'Pack by company'}
        />
        {requirements && <LabelText label='Requirements' text={requirements} />}
      </DetailsBlock>
      <DetailsBlock header='Video' edit={edit} onClick={() => setStep(7)}>
        <FilesPreview videosUrls={videosUrls} />
      </DetailsBlock>
      <label className={'error-label' + (error ? ' show' : '')}>
        {error ?? 'placeholder'}
      </label>
    </div>
  );
}
